import * as React from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Alert } from "reactstrap";

const alertBackgroundColorDictionary: { [key: string]: string } = {
  success: "lightCloud",
  warning: "",
  error: "errorInfo",
};

const alertTextColorDictionary: { [key: string]: string } = {
  success: "primary",
  warning: "black",
  error: "danger",
};

export const Banner: React.FC<{
  type: "success" | "error" | "warning";
  text: string;
  onClose?: () => void;
}> = ({ type, text, onClose }) => {
  return (
    <Alert
      color={type}
      className={`bg-${alertBackgroundColorDictionary[type]} text-${alertTextColorDictionary[type]} border border-${alertTextColorDictionary[type]}`}
      {...(onClose && { toggle: onClose })}
    >
      <AiOutlineInfoCircle
        className={`me-2 text-${alertTextColorDictionary[type]}`}
        size={15}
      />
      <span className={`text-small text-${alertTextColorDictionary[type]}`}>
        {text}
      </span>
    </Alert>
  );
};
